<template>
	<div class="rent-property-form">

		<div class="rent-property-form__text-content">
			<h3 class="font-bold text-[24px] mb-2">{{locales && locales.pages && locales.pages.rent_your_property_fast}}</h3>
			<p>{{locales && locales.pages && locales.pages.fill_rent_form}}</p>
		</div>

		<theme-toggler
				:name="'company_registration'"
				:label="usersApplyCompanyLabel"
				@change="showCompanyTrigger"
		></theme-toggler>

		<theme-input
			v-if="showCompanyInput"
			:label="usersCompanyName"
			name="company[company_name]"
			v-validate="`required|alpha_num_spaces`"
			:isRequired="true"
			:placeholder="usersCompanyNamePlaceholder"
		></theme-input>

		<div tabindex="0" @focus="$event.target.querySelector('input[type=radio]') && $event.target.querySelector('input[type=radio]').focus()">
			<theme-radios
				:label="usersSex"
				name="title_id"
				:options="usersSexOptions"
				v-validate="`required|make_choice`"
				:isRequired="true"
			></theme-radios>
		</div>

		<theme-input
      :label="usersFirstName"
      name="first_name"
      v-validate="`required|alpha_spaces_dash`"
      :isRequired="true"
			:placeholder="usersFirstNamePlaceholder"
		></theme-input>

		<theme-input
      :label="usersMiddleName"
      name="middle_name"
			:placeholder="usersMiddleNamePlaceholder"
		></theme-input>

		<theme-input
      :label="usersLastName"
      name="last_name"
      v-validate="`required|alpha_spaces_dash`"
      :isRequired="true"
			:placeholder="usersLastNamePlaceholder"
		></theme-input>


		<theme-input
      :label="usersPhoneNumber"
      name="phone_number"
      v-validate="`required|phone_number`"
      :isRequired="true"
			:placeholder="usersPhoneNumberPlaceholder"
		></theme-input>

		<theme-input
      :label="usersEmail"
      name="email"
      type="email"
      :trim="true"
      v-validate="`required|email`"
      :isRequired="true"
			:placeholder="usersEmailPlaceholder"
			@input="onEmailInput"
			@blur="checkMail"
		></theme-input>
		<div class="rent-property-form__warning" v-if="!!is_user_already_exists">
				<label class="">{{userAlreadyExists}}</label>
				<input type="hidden" name="user_already_exists" v-validate="`required`">
		</div>  
		
		<theme-input
          :label="usersPassword"
          name="password"
          type="password"
          ref="password"
          :placeholder="usersPasswordPlaceholder"
          v-validate="`required|min:8`"
          :isRequired="true"
        ></theme-input>
        
        
        <theme-input
          :label="usersPasswordRepeat"
          type="password"
          name="confirm_password"
          :placeholder="usersPasswordRepeatPlaceholder"
          v-validate="`required|confirmed:password`"
          :isRequired="true"
        ></theme-input> 		

		<div v-if="isRecaptcha === 'true'" class="">
				<v-recaptcha @validate="checkRecaptcha" :site-key="recaptchaKey"></v-recaptcha>
		</div>

		<button
      id="submitFormBtn"
      class="theme-btn theme-btn--block theme-btn--primary"
      type="submit"
      @click.prevent="submitForm"
    >
      {{ buttonName }}
    </button>

	</div>
</template>

<script>
import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

import ThemeInput from "./ThemeInput.vue";
import ThemeToggler from "./ThemeToggler.vue";
import ThemeRadios from "./ThemeRadios.vue";

export default {
	inject: ['$validator'],
	components: {
		ThemeInput,
		ThemeToggler,
		ThemeRadios
	},
	data () {
		return {
			is_user_already_exists: 0,
			recaptchaTicked: false,
      showCompanyInput: false,
		}
	},
	computed: {
		...mapGetters(["locales"])
	},
	props: {
		buttonName: {
			default: 'Submit',
			type: String
		},
		buttonAlign: {
			default: 'left',
			type: String
		},
		showSuccess: {
			default: 1,
			type: Number
		},
		successText: {
			default: '',
			type: String
		},
		errorText: {
			default: '',
			type: String
		},
		isRecaptcha: {
			default: 'false',
			type: String
		},
		recaptchaMessage: {
			default: 'Please tick recaptcha',
			type: String
		},
		recaptchaKey: {
			default: '',
			type: String
		},
		subscriptionsYourDetails: {
			default: '',
			type: String
		},
		usersCompanyName: {
			default: '',
			type: String
		},
		usersCompanyNamePlaceholder: {
			default: '',
			type: String
		},
		usersApplyCompanyLabel: {
			default: '',
			type: String
		},
		usersSex: {
			default: '',
			type: String
		},
		usersSexOptions: {
			default: () => {},
			type: Object
		},
		usersFirstName: {
			default: '',
			type: String
		},
		usersFirstNamePlaceholder: {
			default: '',
			type: String
		},
		usersMiddleName: {
			default: '',
			type: String
		},
		usersMiddleNamePlaceholder: {
			default: '',
			type: String
		},
		usersLastName: {
			default: '',
			type: String
		},
		usersLastNamePlaceholder: {
			default: '',
			type: String
		},
		usersPhoneNumber: {
			default: '',
			type: String
		},
		usersPhoneNumberPlaceholder: {
			default: '',
			type: String
		},
		usersEmail: {
			default: '',
			type: String
    },
		usersEmailPlaceholder: {
			default: '',
			type: String
    },
    usersBankAccount: {
			default: '',
			type: String
    },
    usersBic: {
			default: '',
			type: String
		},
		userAlreadyExists: {
			default: '',
			type: String
		},
		usersPassword: {
			default: '',
			type: String
    	},
		usersPasswordRepeat: {
			default: '',
			type: String
    	},
		usersPasswordPlaceholder: {
			default: '',
			type: String
    	},
		usersPasswordRepeatPlaceholder: {
			default: '',
			type: String
    	},
	},
	methods: {
		showCompanyTrigger: function (event) {
			if(event == 1){
				this.showCompanyInput = true;
			}else{
				this.showCompanyInput = false;
			}
		},
		onEmailInput: function () {
			this.is_user_already_exists = 0;
		},
		checkMail: function (event) {
			var email = (event.target.value || '').trim();
			if (event.target.value !== email) event.target.value = email;
			if (email == '') return this.is_user_already_exists = 0;
			var vm = this;
			$.ajax({
				url: `/api/users/check-mail`,
				method: 'post',
				data: {
					email:email
				},
				success: function (result) {
					vm.is_user_already_exists = +result;
				},
				error: function () {
				}
			});
		},
		checkRecaptcha: function (result) {
			if (result === false) {
				this.recaptchaTicked = false;
			} else {
				this.recaptchaTicked = true;
			}
		},
		submitForm: function (e) {
			e.preventDefault();
			this.$validator.validateAll().then((res) => {
				if (this.isRecaptcha === 'true') {
					if (!this.recaptchaTicked) {
						sweetalert(window.app.locales.common.error, this.recaptchaMessage, 'error');
						return;
					}
				} 
				if (res) {
					let form = $('#form');
					let data = $('form').serialize();
					var message= this.successText;
					var errorMessage= this.errorText;
					if(this.showSuccess){
						$.ajax({
							url: form.attr('action'),
							method: 'post',
							data: data,
							success: function (result) {
								if(result.url!==undefined){
									if(message!==''){
										sweetalert(window.app.locales.common.success,message, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}else{
										sweetalert(window.app.locales.common.success,window.app.locales.subscriptions.successfully_added, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}
								}
							},
							error: function(result){
								var detail = (window.app && typeof window.app.extractServerError === 'function')
									? window.app.extractServerError({ xhr: result })
									: null;
								var common = (window.app && window.app.locales && window.app.locales.common) || {};
								var title = (detail && detail.title) || common.error || '';
								var message;
								if (errorMessage !== '') {
									message = errorMessage;
								} else if (detail && detail.message) {
									message = detail.message;
								} else {
									message = common.something_went_wrong || common.error || '';
								}
								var redirectUrl = (detail && detail.redirectUrl)
									|| (result && result.responseJSON && result.responseJSON.url) || null;
								sweetalert(title, message, 'error').then(function (res) {
									if (redirectUrl) {
										window.location.replace(redirectUrl);
									}
								});
							}
						});
					}else{
						form.submit();
					}
				} else {
					sweetalert(window.app.locales.common.error, window.app.locales.subscriptions.form_with_errors, 'error');
				}
			});
		}
	}
}
</script>